import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { DateTime } from "luxon";

import Localization from "../../../localization";
import Button from "../../../components/button";
import IconClose from "../../../components/icons/close";
import IconSpinner from "../../../components/icons/spinner";
import {
    changeDynamicBooking,
    changeFaq,
    changeTechnicsBooking,
} from "../../../redux/actions/options";
import { loadPage } from "../../../redux/actions/pages";
import { getUrl, fixExternalLinks } from "../../../utils/helper";
import { getMe } from "../../../redux/selectors/me";

class Technics extends Component {
    componentDidMount() {
        this.props.loadPage("tecnical_residencies");
    }

    _onBookingPress = () => {
        this.props.changeTechnicsBooking(true);
    };

    _onDynamicBookingPress = () => {
        this.props.changeDynamicBooking("technical");
    };

    _renderSection(section, openCall, open, applied) {
        const { locale } = this.props;

        return (
            <div className="flex">
                <div>
                    <div
                        className="article-body text-17 xl:text-23 leading-tight font-bold mt-30 xl:mt-40 whitespace-pre-wrap"
                        dangerouslySetInnerHTML={{
                            __html: fixExternalLinks(openCall.description),
                        }}
                    />
                    {openCall && (
                        <div className="flex flex-col xl:flex-row flex-wrap mt-30 xl:mt-40 xl:-mx-8">
                            {!open && (
                                <Button
                                    text={
                                        Localization[locale].account.button_soon
                                    }
                                    comingSoon={true}
                                    style={"mb-8 xl:m-8"}
                                    textStyle={
                                        "font-bold text-20 xl:text-23 text-blue"
                                    }
                                />
                            )}
                            {open && (
                                <Button
                                    text={
                                        Localization[locale].account
                                            .button_application
                                    }
                                    textStyle={
                                        "w-full font-bold text-20 xl:text-23 z-10 text-center transition hover-hover:group-hover:text-white text-blue"
                                    }
                                    style={"mb-8 xl:m-8"}
                                    wrapperStyle="px-20"
                                    backgroundColor={"bg-grey"}
                                    onClick={
                                        openCall.form
                                            ? this._onDynamicBookingPress
                                            : this._onBookingPress
                                    }
                                />
                            )}
                            {openCall.rules && (
                                <Button
                                    text={
                                        openCall.rules_button ||
                                        Localization[locale].account
                                            .button_rules
                                    }
                                    textStyle={
                                        "w-full font-bold text-20 xl:text-23 z-10 text-center transition hover-hover:group-hover:text-white text-blue"
                                    }
                                    style={"mb-8 xl:m-8"}
                                    wrapperStyle="px-20"
                                    backgroundColor={"bg-grey"}
                                    to={getUrl("opencalls/technic/rules")}
                                />
                            )}
                            {openCall.judges && (
                                <Button
                                    text={
                                        openCall.judges_button ||
                                        Localization[locale].account.button_jury
                                    }
                                    textStyle={
                                        "w-full font-bold text-20 xl:text-23 z-10 text-center transition hover-hover:group-hover:text-white text-blue"
                                    }
                                    style={"mb-8 xl:m-8"}
                                    wrapperStyle="px-20"
                                    backgroundColor={"bg-grey"}
                                    to={getUrl("opencalls/technic/judges")}
                                />
                            )}
                            {openCall.external && (
                                <Button
                                    text={
                                        openCall.external_button ||
                                        Localization[locale].account
                                            .button_external
                                    }
                                    textStyle={
                                        "w-full font-bold text-20 xl:text-23 z-10 text-center transition hover-hover:group-hover:text-white text-blue"
                                    }
                                    style={"mb-8 xl:m-8"}
                                    wrapperStyle="px-20"
                                    backgroundColor={"bg-grey"}
                                    to={getUrl("opencalls/technic/external")}
                                />
                            )}
                            {openCall.mentors && (
                                <Button
                                    text={
                                        openCall.mentors_button ||
                                        Localization[locale].account
                                            .button_mentors
                                    }
                                    textStyle={
                                        "w-full font-bold text-20 xl:text-23 z-10 text-center transition hover-hover:group-hover:text-white text-blue"
                                    }
                                    style={"mb-8 xl:m-8"}
                                    wrapperStyle="px-20"
                                    backgroundColor={"bg-grey"}
                                    to={getUrl("opencalls/technic/mentors")}
                                />
                            )}
                            <Button
                                text={Localization[locale].account.button_faqs}
                                textStyle={
                                    "font-bold text-20 xl:text-23 z-10 text-center transition hover-hover:group-hover:text-white text-blue"
                                }
                                backgroundColor={"bg-grey"}
                                onClick={() => {
                                    this.props.changeFaq(true, 0);
                                }}
                                toTarget="_blank"
                                style={"mb-8 xl:m-8"}
                                wrapperStyle="px-20"
                            />
                        </div>
                    )}
                </div>
            </div>
        );
    }

    _renderApplication(application) {
        const { locale } = this.props;

        let className = "flex items-start py-16 border-b border-blue";

        return (
            <div key={application.id} className={className}>
                <div className="flex-1">
                    <div className="flex flex-row">
                        <p className="text-17 xl:text-30 font-judge font-bold w-100 xl:w-200">
                            {DateTime.fromISO(
                                application.created_at
                            ).toLocaleString(DateTime.DATE_SHORT)}
                        </p>
                        <p className="text-17 xl:text-30 font-judge font-bold flex-1">
                            {application.title}
                        </p>
                        <a
                            href={"/" + locale + "/pdf/" + application.id}
                            target="_blank"
                            className="underline text-17 xl:text-30 font-judge font-bold"
                            title={"PDF"}
                        >
                            PDF
                        </a>
                    </div>
                </div>
            </div>
        );
    }

    _renderHistory() {
        const { locale, openCallsDataApplications, openCallsData } = this.props;

        let openCall = openCallsData.find((item) => item.type === "technical");

        if (
            !openCall ||
            !openCallsDataApplications ||
            openCallsDataApplications.length === 0
        )
            return null;

        let applications = openCallsDataApplications.filter(
            (item) => item.open_call_id === openCall.id
        );

        if (applications.length === 0) return null;

        return (
            <div className="mt-30 xl:mt-40">
                <p className="text-30 font-judge font-bold">
                    {Localization[locale].account.application_history}
                </p>
                <div className="border-t border-blue mt-30 xl:mt-40">
                    {applications.map((application) =>
                        this._renderApplication(application)
                    )}
                </div>
            </div>
        );
    }

    render() {
        const {
            locale,
            technicalResidenciesData,
            openCallsData,
            openCallsDataApplications,
            user,
        } = this.props;

        if (!technicalResidenciesData)
            return (
                <div className="flex h-screen xl:h-auto items-center justify-center">
                    <IconSpinner className="animate-spin w-25 xl:w-32 h-25 xl:h-32 text-blue" />
                </div>
            );

        let openCallOpen =
            user && (user.role === "admin" || user.role === "super_admin");
        let openCallApplied = false;
        let openCall = openCallsData.find((item) => item.type === "technical");

        if (openCall) {
            const findApplication = openCallsDataApplications.find(
                (item) => item.open_call_id === openCall.id
            );

            if (findApplication) openCallApplied = true;

            const now = DateTime.local();
            const begin = DateTime.fromISO(openCall.begin);
            const end = DateTime.fromISO(openCall.end);

            if (
                now.toMillis() >= begin.toMillis() &&
                now.toMillis() <= end.toMillis()
            ) {
                openCallOpen = true;
            }
        }

        return (
            <div className="flex flex-col">
                <div className="relative">
                    <p className="text-30 font-judge uppercase font-bold mr-100">
                        {Localization[locale].account.technics_type}
                    </p>
                    <div className="xl:hidden absolute right-0 top-0">
                        <Button
                            icon={
                                <IconClose className="w-25 h-25 z-10 transition hover-hover:group-hover:text-white text-blue" />
                            }
                            to={getUrl("account")}
                            style={"w-50 xl:w-70"}
                        />
                    </div>
                </div>
                {openCall ? (
                    <p className="text-30 xl:text-60 font-bold mt-40">
                        {openCall.title}
                    </p>
                ) : (
                    <p className="text-30 xl:text-60 font-bold mt-40">
                        {Localization[locale].account.button_soon}
                    </p>
                )}
                {openCall &&
                    technicalResidenciesData.content.map((section) =>
                        this._renderSection(
                            section,
                            openCall,
                            openCallOpen,
                            openCallApplied
                        )
                    )}
                {this._renderHistory()}
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    locale: state.app.locale,
    technicalResidenciesData: state.pages.tecnical_residencies,
    openCallsData: state.openCalls.data,
    openCallsDataApplications: state.openCalls.dataApplications,
    user: getMe(state),
});

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(
        {
            changeDynamicBooking,
            changeTechnicsBooking,
            loadPage,
            changeFaq,
        },
        dispatch
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(Technics);
